/* eslint-disable no-unused-vars */
import type { TAnalytics } from '@/containers/AnalyticsContainer/types';

declare global {
  interface Window {
    ym: (
      counterId: number,
      method: 'reachGoal',
      goalName: string,
      params?: Record<string, any>
    ) => void;
  }
}

export const METRICA_ID = process.env.NEXT_PUBLIC_METRICA_ID;

export const logMetricaEvent = <K extends keyof TAnalytics>(
  event: K,
  ...params: TAnalytics[K] extends undefined | null
    ? [undefined?]
    : [TAnalytics[K]]
) => {
  if (METRICA_ID) {
    window.ym(
      parseInt(METRICA_ID),
      'reachGoal',
      event,
      params?.[0] ?? undefined
    );
  }
};
